import { useState } from "react";
import React from "react";
import {
  Button,
  TextField,
  Select,
  MenuItem,
  SelectChangeEvent,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useNavigate } from "react-router-dom";

const vendors = [
  "#ST001 - Downtown Store",
  "#ST002 - City Mall Store",
  "#ST003 - Central Plaza",
]

const AddDiscount = () => {
  const [personName, setPersonName] = React.useState<string[]>([]);

  const handleChange = (event: SelectChangeEvent<typeof personName>) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };

  const [type, setType] = React.useState("default");
  const handleTypeChange = (event: SelectChangeEvent) => {
    setType(event.target.value as string);
  };

  const [productCategories, setProductCategories] = useState<string[]>([]);
  const [productsByCategory, setProductsByCategory] = useState<Record<string, string[]>>({});  

  const productData: Record<string, string[]> = {
    Smothies: ["Strawberry Smoothie", "Mango Smoothie", "Banana Smoothie"],
    Beverages: ["Cold Coffee", "Hot Chocolate", "Lemon Soda"],
  };

  const [store, setStore] = useState("");
  const navigate = useNavigate();

  return (
    <>
      <div className="main_title">
        <h1>Add Discount and Coupon</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
          <button onClick={() => navigate("/discounts")}>Discounts and Coupons</button> - Add Discount and Coupon
        </p>
      </div>
      <div className="cards custom_form_details">
        <div className="form">
          <div className="gap_m w_100">
            <div className="control_group w_50">
              <label htmlFor="text">Offer/Discount Name</label>
              <TextField
                id="text"
                placeholder="Enter Discount Name"
                fullWidth
                hiddenLabel
              />
            </div>
            <div className="control_group w_50">
              <label htmlFor="text">Coupon Code</label>
              <TextField
                disabled
                id="text"
                placeholder="Will be auto-generated"
                fullWidth
                hiddenLabel
              />
            </div>
            <div className="control_group w_25">
              <label htmlFor="text">Minimum Sales (Orders)</label>
              <TextField
                id="text"
                placeholder="eg . 10 orders"
                fullWidth
                hiddenLabel
              />
            </div>
            <div className="control_group w_25">
              <label htmlFor="email">Discount Type</label>
              <Select fullWidth value={type} onChange={handleTypeChange}>
                <MenuItem disabled value="default">
                  Select Discount Type
                </MenuItem>
                <MenuItem value="broadcast">percentage</MenuItem>
                <MenuItem value="email">Flaat</MenuItem>
                <MenuItem value="email">Both (XX% off up to ₹YY)</MenuItem>
              </Select>
            </div>

            <div className="control_group w_25">
              <label htmlFor="text">Discount (%)</label>
              <TextField
                id="text"
                placeholder="Enter Discount (%)"
                fullWidth
                hiddenLabel
              />
            </div>
            <div className="control_group w_25">
              <label htmlFor="text">Flat Amount</label>
              <TextField
                id="text"
                placeholder="Enter Flat Amount"
                fullWidth
                hiddenLabel
              />
            </div>


            <div className="control_group w_50">
              <label htmlFor="email">Applicable Time Slot</label>
              <Select fullWidth value={type} onChange={handleTypeChange}>
                <MenuItem disabled value="default">
                  Select Time Slot
                </MenuItem>
                <MenuItem value="broadcast">Morning (8 AM - 12 PM)</MenuItem>
                <MenuItem value="email">Afternoon (12 PM - 4 PM)</MenuItem>
                <MenuItem value="email">Afternoon (12 PM - 4 PM)</MenuItem>
              </Select>
            </div>

            <div className="control_group w_50">
              <label htmlFor="email">Valid From - To</label>

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  className="form_control"
                  slots={{
                    openPickerIcon: () => (
                      <img src="/static/images/date_icon.svg" alt="Pick date" />
                    ),
                  }}
                  slotProps={{
                    textField: {
                      id: "dob",
                      placeholder: "Select Date",
                      fullWidth: true,
                      hiddenLabel: true,
                    },
                  }}
                  desktopModeMediaQuery="(min-width:0px)"
                />
              </LocalizationProvider>
            </div>

            <div className="control_group w_50">
              <label>Applicable Product Category</label>
              <Select
                multiple
                fullWidth
                displayEmpty
                value={productCategories}
                onChange={(e) => {
                  const selected = e.target.value as string[];
                  setProductCategories(selected);

                  // Initialize empty product lists for new selections
                  selected.forEach((cat) => {
                    if (!productsByCategory[cat]) {
                      setProductsByCategory((prev) => ({
                        ...prev,
                        [cat]: [],
                      }));
                    }
                  });
                }}
                renderValue={(selected) => {
                  if (selected.length === 0) return "Choose Product Category";
                  return selected.join(", ");
                }}
              >
                <MenuItem disabled value="">
                  Choose Product Category
                </MenuItem>
                <MenuItem value="Smothies">Smothies</MenuItem>
                <MenuItem value="Beverages">Beverages</MenuItem>
              </Select>
            </div>

            {productCategories.map((cat) => (
              <div key={cat} className="control_group w_50">
                <label>{cat} Products</label>

                <Select
                  multiple
                  fullWidth
                  value={productsByCategory[cat] || []}
                  onChange={(e) => {
                    const selectedProducts = e.target.value as string[];
                    setProductsByCategory((prev) => ({
                      ...prev,
                      [cat]: selectedProducts,
                    }));
                  }}
                  renderValue={(selected) => {
                    if (selected.length === 0) return `Select ${cat} Products`;
                    return selected.join(", ");
                  }}
                >
                  <MenuItem disabled value="">
                    Select {cat} Products
                  </MenuItem>

                  {productData[cat].map((prod) => (
                    <MenuItem key={prod} value={prod}>
                      {prod}
                    </MenuItem>
                  ))}
                </Select>
              </div>
            ))}

            <div className="control_group w_50">
              <label htmlFor="store">Store</label>

              <Select
                id="store"
                fullWidth
                value={store}
                onChange={(e) => setStore(e.target.value)}
                displayEmpty
                hiddenLabel
              >
                <MenuItem disabled value="">
                  Select Store
                </MenuItem>

                {vendors.map((vendor) => (
                  <MenuItem key={vendor} value={vendor}>
                    {vendor}
                  </MenuItem>
                ))}
              </Select>
            </div>
          </div>
        </div>
      </div>
      <div className="form_btn">
        <Button
          className="btn btn_primary"
          variant="contained"


        >
          Save
        </Button>
      </div>

    </>
  );
};

export default AddDiscount;
